import { compareVersions } from "compare-versions";
import { HardwareModels } from "types/productTypes";
import { WifiSecurity } from "./wifiDeviceState";
import { toAsciiSafeJson } from "./managementConfigFile";

export interface WifiCredentials {
  ssid: string;
  password: string;
  isOpenNetwork: boolean;
}

export type WifiCredentialsError = "ssidRequired" | "passwordRequired" | "unsupportedSecurity";

// First headset build that reads wifi.json. Below it the tool is hidden.
export const WIFI_REQUEST_MIN_APP_VERSION = "2.8.6";

export function validateWifiCredentials(
  { ssid, password, isOpenNetwork }: WifiCredentials,
  security?: WifiSecurity | null,
): WifiCredentialsError | null {
  // An identity and certificate cannot be expressed as an SSID and passphrase.
  if (security === "eap") return "unsupportedSecurity";
  if (ssid.trim() === "") return "ssidRequired";
  if (!isOpenNetwork && password === "") return "passwordRequired";
  return null;
}

const MODELS_WITHOUT_APP_WIFI_JOIN: readonly string[] = [
  HardwareModels.Dpvr,
  HardwareModels.HtcFocusVision,
];

export function supportsUsbWifiProvisioning(model: string | null | undefined): boolean {
  return !MODELS_WITHOUT_APP_WIFI_JOIN.includes(model ?? "");
}

export function supportsWifiRequestFile(appVersion: string | null | undefined): boolean {
  const version = (appVersion ?? "").trim();
  if (version === "") return false;
  try {
    return compareVersions(version, WIFI_REQUEST_MIN_APP_VERSION) >= 0;
  } catch {
    return false;
  }
}

// ASCII-safe because the headset reads the file with Encoding.ASCII.
export function wifiRequestJson({ ssid, password }: Pick<WifiCredentials, "ssid" | "password">) {
  return toAsciiSafeJson({ ssid: ssid.trim(), password });
}
